<template>
  <div :class="{ 'form-group': label }">
    <div class="col-lg-4" v-if="label">
      <label class="control-label">Hire</label>
    </div>
    <div :class="{ 'col-lg-8': label }">
      <template v-if="hires.length">
        <p>
          Multiple hires found for the hire vehicle on the date of
          contravention, please select the correct hire:
        </p>

        <select class="form-control" @input="selectHire($event.target.value)">
          <option value="">Please Select</option>
          <option
            :key="hireIndex"
            :value="hire.id"
            v-for="(hire, hireIndex) in hires"
          >
            {{ hire.incident?.source?.claim_reference }} -
            {{ hire.vehicle?.start_date | date }} -
            <template v-if="hire.vehicle?.end_date">{{
              hire.vehicle.end_date | date
            }}</template
            ><template v-if="!hire.vehicle?.end_date">Ongoing</template>
          </option>
        </select>
      </template>

      <div v-if="result">
        Reference: {{ result.incident?.source?.claim_reference }}<br />
        Started: {{ result.vehicle?.start_date | date }}<br />
        Ended:
        <span v-if="result.vehicle?.end_date">{{
          result.vehicle.end_date | date
        }}</span
        ><span v-else>Ongoing</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: String,
    hire: Object,
    date: {
      required: false
    },
    vehicleId: {
      required: false
    }
  },

  data() {
    return {
      result: null,
      hires: []
    };
  },

  mounted() {
    if (this.hire) {
      this.result = this.hire;
    }
  },

  methods: {
    setHire(hire) {
      this.result = hire;
      this.hires = [];

      this.$emit('input', hire.id);
      this.$emit('selected', hire);
    },

    selectHire(id) {
      const hire = this.hires.find(hire => hire.id == id);

      if (hire) {
        this.setHire(hire);
      }
    },

    searchForHire() {
      if (this.date && this.vehicleId) {
        const date = window.DateManager.format(this.date, 'YYYY-MM-DD');

        window.Ajax.get(
          `hires?parts=incident&filter[date]=${date}&filter[vehicle_id]=${this.vehicleId}`
        ).then(({ data }) => {
          if (data.length) {
            this.result = null;

            if (data.length == 1) {
              this.setHire(data[0]);
            } else {
              this.hires = data;
            }
          }
        });
      }
    }
  },

  watch: {
    date(change, old) {
      if (
        window.DateManager.differenceInDays(
          window.DateManager.parse(change),
          window.DateManager.parse(old)
        )
      ) {
        this.searchForHire();
      }
    },

    vehicleId() {
      this.searchForHire();
    }
  }
};
</script>
